import Ajv from "ajv";
import { get } from "lodash";
import licenseList from "./defs";
import licenseFeatureList from "./features";
import { WILDCARD_ORG_ID } from "../api/API";

const _baseLicense = {
  tags: [],
  api: [
    { rule: "settings.read", allow: true },
    { rule: "me.*", allow: true },
  ],
  page: [{ rule: "getstarted/.*", allow: true }],
  schema: [],
};

const LICENSE_TYPES = [
  "FREE",
  "M365",
  "CLOUD",
  "ADVANCED",
  "SIEM_PRO",
  "SIEM_ENDPOINT",
  "XDR",
];

const FEATURE_EXTENTIONS = ["tags", "api", "page", "schema"];

const BluLicense = class {
  licenseMap = {};

  isSet() {
    return Object.keys(this.licenseMap).length > 0;
  }

  set orgId(orgId) {
    this._orgId = orgId;
  }

  get orgId() {
    return this._orgId;
  }

  setLicenseMap(licenseMap) {
    this.licenseMap = {};
    licenseMap.forEach((l) => (this.licenseMap[l.id] = l.config || {}));
  }

  generateLicense(licenseType, licenseFeatures) {
    const licenseDef = {
      tags: [
        ...(licenseList[licenseType]["tags"] || []),
        ..._baseLicense["tags"],
      ],
      api: [...(licenseList[licenseType]["api"] || []), ..._baseLicense["api"]],
      page: [
        ...(licenseList[licenseType]["page"] || []),
        ..._baseLicense["page"],
      ],
      schema: [
        ...(licenseList[licenseType]["schema"] || []),
        ..._baseLicense["schema"],
      ],
    };

    if (licenseFeatures && licenseFeatures.length) {
      licenseFeatures.forEach((feature) => {
        const licenseFeature = licenseFeatureList[feature];
        FEATURE_EXTENTIONS.forEach((attr) => {
          if (licenseFeature && licenseFeature[attr]) {
            licenseDef[attr] = [...licenseFeature[attr], ...licenseDef[attr]];
          }
        });
      });
    }
    return licenseDef;
  }

  getLicenseDef() {
    if (this._orgId === WILDCARD_ORG_ID) {
      return this.generateLicense("ADVANCED");
    }
    if (this.licenseMap[this._orgId]) {
      if (
        this.licenseMap[this._orgId].license &&
        LICENSE_TYPES.includes(this.licenseMap[this._orgId].license)
      ) {
        return this.generateLicense(
          this.licenseMap[this._orgId].license,
          this.licenseMap[this._orgId].license_features
        );
      }
      return this.generateLicense(
        "ADVANCED",
        this.licenseMap[this._orgId].license_features
      );
    } else {
      return { ..._baseLicense };
    }
  }

  hasFeature(feature) {
    const features = get(
      this.licenseMap,
      [this._orgId, "license_features"],
      []
    );
    return features.includes(feature);
  }

  isAllowedPage(rule) {
    const license = this.getLicenseDef();
    const matchRule = license.page.find((k) => !!rule.match(k.rule));
    return !!matchRule && matchRule.allow;
  }

  isAllowedAPI(rule) {
    const license = this.getLicenseDef();
    const matchRule = license.api.find((k) => !!rule.match(k.rule));
    return !!matchRule && matchRule.allow;
  }

  isTagged(tag) {
    const license = this.getLicenseDef();
    return license.tags.includes(tag);
  }

  getSchema(rule) {
    const license = this.getLicenseDef();
    const matchRule = license.schema.find((k) => !!rule.match(k.rule));
    if (matchRule) {
      const ajv = new Ajv();
      return ajv.compile({ ...matchRule, additionalProperties: true });
    } else {
      return false;
    }
  }
};

export default new BluLicense();
